import { AgGridModule } from '@ag-grid-community/angular';
import { ColDef, ModuleRegistry, ValueFormatterParams } from '@ag-grid-community/core';
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import { StatusBarModule } from '@ag-grid-enterprise/status-bar';
import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, computed } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ExportsMonitoringChannel } from 'exports/interfaces/exports-monitoring-channel.interface';
import { ExportsMonitoringService } from 'exports/services/exports-monitoring.service';
import { BaseGrid } from 'shared/abstract/base-grid';

@Component({
    selector: 'app-exports-monitoring-channel-overview',
    imports: [TranslateModule, AgGridModule, CommonModule],
    templateUrl: './exports-monitoring-channel-overview.component.html',
    styleUrl: './exports-monitoring-channel-overview.component.scss',
})
export class ExportsMonitoringChannelOverviewComponent extends BaseGrid implements OnInit {
    public columnDefs: ColDef[] = [
        {
            field: 'channelName',
            headerName: 'Channel Name',
            cellRenderer: 'distributionTrackingChannelLogoCellRenderer',
            valueFormatter: (params: ValueFormatterParams) => {
                return params.data.channelName;
            },
            cellRendererParams: ((params: any) => {
                return {
                    linkUrl: `/export-management/exports-monitoring/${params.data.id}`,
                };
            }) as any,
            sort: 'asc',
            sortIndex: 0,
        },
        { field: 'lastExportDateOutput', valueFormatter: this.unixDateFormatter },
        {
            headerName: 'Status',
            field: 'successRate',
            cellRenderer: 'distributionTrackingStatusCellRenderer',
            enableValue: true,
        },
        {
            colId: 'actions',
            filter: false,
            resizable: false,
            sortable: false,
            minWidth: 110,
            maxWidth: 110,
            cellRenderer: 'actionButtonsCellRenderer',
            cellRendererParams: {
                buttons: [
                    {
                        clickAction: this.openChannelDetailClickHandler.bind(this),
                        icon: 'chevron-right',
                        tooltip: this.translateService.instant('exports.monitoring.viewChannelDetails'),
                    },
                ],
            },
        },
    ];

    formattedLastUpdatedAtTimestamp = computed(() => {
        const lastUpdatedAtTimestamp = this.exportsMonitoringService.lastUpdatedAtTimestamp();
        if (lastUpdatedAtTimestamp) {
            const date = new Date(lastUpdatedAtTimestamp * 1000);
            return date.toLocaleString();
        }
        return '-';
    });

    constructor(
        router: Router,
        activatedRoute: ActivatedRoute,
        destroyRef: DestroyRef,
        public exportsMonitoringService: ExportsMonitoringService,
        private translateService: TranslateService,
    ) {
        ModuleRegistry.registerModules([ServerSideRowModelModule, StatusBarModule, SetFilterModule]);
        super(exportsMonitoringService, router, activatedRoute, destroyRef);
    }

    public openChannelDetailClickHandler(rowData: ExportsMonitoringChannel) {
        this.router.navigate([rowData.id], {
            relativeTo: this.activatedRoute,
        });
    }

    ngOnInit(): void {
        this.exportsMonitoringService.getLastProcessingDate().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
    }
}
